<template>
    <v-data-table
        :headers="headers"
        :items="listItems"
        :loading="isLoading"
        hide-default-footer
        :header-props="{ sortIcon: '' }"
        :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
        :no-results-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
        :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
        class="noMinWidth"
    >
    <!-- Top Slot -->
        <template v-slot:top>
            <v-row class="pb-3">
                <v-col cols="2">
                    <DropdownFilter 
                        context="ProjectsProfitAndLossFilterCostGroup"
                        label="lang_LABEL_RELEASES_CAPTION_COST_GROUP"
                        :items="costGroupItems"
                        :alvqa="alvqa + '-dropdown-filter-cost-group'"
                        :defaultValueNull="true"
                    />
                </v-col>
                <v-col 
                    cols="3"
                    class="pt-8"
                    :alvqa="alvqa + 'costs-sum'"
                >
                    {{ $t('lang_GENERIC_CAPTION_SUM') }}:
                    {{ $n(getSumOfDisplayedRows, 'number') }} {{ $store.getters.getSelectedCurrency }}
                </v-col>
            </v-row>
        </template>

    <!-- Headers -->
        <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
            <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
        </template>
    
    <!-- Items -->
        <template v-slot:[`item.costGroup`]="{ item }">
            <div :alvqa="alvqa + '-list-row-text-cost-group-'+ item.costGroup">
                {{ getCostGroup(item.costGroup) }}
            </div>
        </template>
        <template v-slot:[`item.budgetPercent`]="{ item }">
            <div 
                class="text-right"
                :alvqa="alvqa + '-list-row-text-budget-percent-'+ item.costGroup"
            >
                {{ $alvPlugin.getNumberLocalization(item.budgetPercent, 'number') }}
            </div>
        </template>
        <template v-slot:[`item.difference`]="{ item }">
            <div 
                class="text-right"
                :alvqa="alvqa + '-list-row-text-difference-'+ item.costGroup"
            >
                {{ $alvPlugin.getNumberLocalization(item.difference, 'number') }}
            </div>
        </template>
        <template v-slot:[`item.budget`]="{ item }">
            <div 
                class="text-right"
                :alvqa="alvqa + '-list-row-text-budget-'+ item.costGroup"
            >
                {{ $alvPlugin.getNumberLocalization(item.budget, 'number') }}
            </div>
        </template>
        <template v-slot:[`item.costsResult`]="{ item }">
            <div 
                class="text-right"
                :alvqa="alvqa + '-list-row-text-result-'+ item.costGroup"
            >
                {{ $alvPlugin.getNumberLocalization(item.costsResult, 'number') }}
            </div>
        </template>
    </v-data-table>
</template>

<script>
import { DropdownGenericCostGroupTypes } from '@/assets/dropdowns/alvDropdowns.js'

import DropdownFilter from '@/components/_filters/DropdownFilter'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "ProjectsProfitAndLossCostsDataTableReadOnly",
    components: {
        DropdownFilter,
        BaseTooltip
    },
    props: {
        projectsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'label-projects-list-row-' + this.projectsAlvId + '-read-only-panel-profit-and-loss-costs',
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_LABEL_RELEASES_PANEL_CAPTION_COSTS"), 
                    align: "left", 
                    value: "costGroup",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-costs',
                    sortable: false,
                    filter: this.filterCostGroup,
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_BUDGET') + " %", 
                    align: "right", 
                    value: "budgetPercent",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-budget-percent'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DIFF') + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "difference",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-difference'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_BUDGET') + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "budget",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-budget'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ACTUAL') + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "costsResult",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-result'
                }
            ]
        },
        listItems() { return this.$store.getters.getProjectsProfitAndLossCosts },
        isLoading() { return this.$store.getters.getProjectsProfitAndLossIsLoading },
        costGroupItems() {
            let costGroup = JSON.parse(JSON.stringify(DropdownGenericCostGroupTypes))
            costGroup.forEach(element => {
                element.text = this.$t(element.text)
            });
            costGroup.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)
            return costGroup
        },
        getSumOfDisplayedRows() {
            let selected = this.$store.getters.getSelectedProjectsProfitAndLossFilterCostGroup
            let sum = 0

            // If api call for the panel is still pending we return default value 0
            if(this.listItems === undefined) return sum
            // if no filter is set, just sum up the "IST-amount" of all rows.
            if(!selected) sum = this.listItems.reduce((prev, cur) => prev + this.$alvPlugin.stringToNumber(cur.costsResult), 0)
            else { // if the filter is set
                this.listItems.forEach(row => {
                    if(row.costGroup === selected) sum += this.$alvPlugin.stringToNumber(row.costsResult)
                })
            }
            
            return sum
        }
    },
    methods: {
        getCostGroup(costGroupvalue) {

            let costGroupsTypes = DropdownGenericCostGroupTypes

            if(costGroupsTypes === null || costGroupsTypes === undefined) {
                return ''
            } else {
                let match = costGroupsTypes.find(type => {
                return type.value === costGroupvalue
                })

                if(match !== undefined){
                    return this.$t(match.text)
                }
            }
        },
        filterCostGroup(value) {
            // https://www.codeply.com/p/krbUh6q9yE
            let selected = this.$store.getters.getSelectedProjectsProfitAndLossFilterCostGroup

            if (!selected) return true // return "true" for all rows in data table = show all rows (no filter selected)
            else return value === selected // check if the value of the row is matching the filter and show row in data table
        }
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>